import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  roles: [],
  permissions: [],
  menus: [],
}

const aclSlice = createSlice({
  name: 'acl',
  initialState,
  reducers: {
    setRoles(state, action) {
      state.roles = action.payload
    },

    setPermissions(state, action) {
      state.permissions = action.payload
    },

    setMenus(state, action) {
      state.menus = action.payload
    },

    clearAccessControl(state) {
      return initialState
    },
  },
})

export const {
  setRoles,
  setPermissions,
  setMenus,
  clearAccessControl,
} = aclSlice.actions

export default aclSlice.reducer
